/** Artist display name / URL segment from Shopify product metafields (matches shop filters). */
export function getArtistNameFromMetafields(metafields) {
  if (!metafields?.length) {
    return ``;
  }
  const row = metafields.find((field) => field.key === `artist`);
  return row?.value ?? ``;
}

export function shopifyProductsByHandle(nodes) {
  const map = {};
  for (const node of nodes ?? []) {
    if (node?.handle) {
      map[node.handle] = node;
    }
  }
  return map;
}

/** Resize Shopify CDN image URLs when Gatsby-processed assets are unavailable. */
export function shopifySizedSrc(src, width = 1000) {
  if (!src || typeof src !== `string`) {
    return src;
  }
  if (!src.includes(`cdn.shopify.com`)) {
    return src;
  }
  const separator = src.includes(`?`) ? `&` : `?`;
  return `${src}${separator}width=${width}`;
}
